module.exports = __webpack_public_path__ + "img/batalla-maipu.b2db03cf.jpg";